module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_costa_rica-0bb57f9f.png";